export const GeneralConfig = {
  isDemo: false,
  hasStoreModule: true,
  dateFormat: 'MMM d, yyyy h:mm a',
  language: 'en',
};
